import axios from 'axios';
import { isPreview } from "../helpers/authHelper";
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';
export const FETCH_USAGE_HISTORY_DATA = {
  FETCH_USAGE_HISTORY_DATA: 'FETCH_USAGE_HISTORY_DATA',
  FETCH_USAGE_HISTORY_DATA_FAILED: 'FETCH_USAGE_HISTORY_DATA_FAILED'
};
export const FETCH_USAGE_SUMMARY_DATA_SUCCESS = 'FETCH_USAGE_SUMMARY_DATA_SUCCESS';
export const FETCH_USAGE_SUMMARY_DATA_FAILED = 'FETCH_USAGE_SUMMARY_DATA_FAILED';

export function fetchUsageHistoryChartData(uuid, options) {
  return dispatch => {
    axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + uuid + '/usage-chart-data', {
        params: options
    }).then(
      (response) => {
        dispatch({
          type: FETCH_USAGE_HISTORY_DATA.FETCH_USAGE_HISTORY_DATA,
          payload: response.data.payload
        })
      },
      (error) => {
        dispatch({
          type: FETCH_USAGE_HISTORY_DATA.FETCH_USAGE_HISTORY_DATA_FAILED,
          payload: error
        })
      }
    )
  }
}

export function fetchUsageSummaryData(uuid, dateFormat,measurementType, templateName, locale) {
  let params = {
    "measurement-type": measurementType,
    "date-format": dateFormat,
    "locale": locale
  }
  if(isPreview()){
    params.templateName = templateName;
  }
  return dispatch => {
    axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + uuid + '/usage-widget-data', {
      params
    }).then(
      (response) => {
        dispatch({
          type: FETCH_USAGE_SUMMARY_DATA_SUCCESS,
          payload: response.data.payload
        })
      },
      (error) =>{
        dispatch({
            type: FETCH_USAGE_SUMMARY_DATA_FAILED,
            payload: error
        })
      }
    )
  }
}